import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCoreAssortmentCount } from 'b2b-apps/shop/product/redux/coreAssortment/actionCreators';
import { getCoreAssortment } from 'b2b-apps/shop/product/redux/coreAssortment/selectors';

const useCoreAssortmentCount = (): number => {
  const dispatch = useDispatch();
  const coreAssortmentCount = useSelector(getCoreAssortment);

  useEffect(() => {
    dispatch(fetchCoreAssortmentCount());
  }, [dispatch]);

  return coreAssortmentCount.data?.count || 0;
};

export {
  useCoreAssortmentCount,
};
